import type { MessageDescriptor } from 'react-intl';
import type { ReplyThread } from '../outreachTypes';
import { inboxMessages as messages } from './inboxMessages';

/** The mailbox states in which `inbox.answer` sends (`ANSWER_HEALTH` of music24-api). */
const ANSWER_HEALTH = ['ok', 'warming', 'paused'];

/**
 * Why the thread takes no answer, or null when `thread.canAnswer` is true. The API answers only
 * the flag, so the reason comes from the mailbox: no mailbox, a mailbox that cannot send, else a
 * stop of the address (suppression, opt-out, "this artist only" stop, "Do not contact").
 */
export function answerBlockMessage(
  thread: Pick<ReplyThread, 'canAnswer' | 'mailbox'>
): { descriptor: MessageDescriptor; values?: Record<string, string> } | null {
  if (thread.canAnswer) {
    return null;
  }
  if (thread.mailbox === null) {
    return { descriptor: messages.cannotAnswerNoMailbox };
  }
  if (!ANSWER_HEALTH.includes(thread.mailbox.health)) {
    return { descriptor: messages.cannotAnswerMailbox, values: { address: thread.mailbox.address } };
  }
  return { descriptor: messages.cannotAnswerStopped };
}
